import { render, staticRenderFns } from "./view-wrapper.component.vue?vue&type=template&id=8c972eb4"
import script from "./view-wrapper.component.ts?vue&type=script&lang=ts&external"
export * from "./view-wrapper.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports